var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('countdown',{attrs:{"countdown":_vm.startsIn,"countdown-color":_vm.countdownColor,"label":_vm.label,"label-color":_vm.labelColor},on:{"finished":function($event){_vm.isStarted = true}}})}
var staticRenderFns = []

export { render, staticRenderFns }